<template>
  <div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">Manage expenses</div>
            <fieldset class="border p-3">
              <div></div>
              <div>
                <div class="expensesLoader">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i
                    class="fa fa-spinner fa-spin"
                    style="font-size: 24px; color: blue"
                  ></i
                  >loading sales...
                </div>
                <vue-good-table
                  :columns="columns"
                  :rows="systemExpenses"
                  :fixed-header="true"
                  :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 6,
                    position: 'bottom',
                    perPageDropdown: [3, 7, 9],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                  }"
                >
                </vue-good-table>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Expense no",
          field: "expense_number",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter expenses number",
          },
        },
        {
          label: "Expense date",
          field: "expenses_date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy", // outputs Mar 16th 2018
        },
        {
          label: "Expense total",
          field: "expense_total",
          type: "text",
        },
      ],
    };
  },
  created() {
    this.loadExpenses();
  },
  computed: {
    ...mapGetters(["systemExpenses"]),
  },
  methods: {
    ...mapActions(["loadExpenses"]),
  },
};
</script>


// WEBPACK FOOTER //
// src/expenses/manageexpenses.vue